import { ClassAttributes, createElement } from 'react';

import Component from '../component/compound/FormattedSnackbar';
import { Consumer as DependencyConsumer } from '../context/dependency';
import { Consumer as StateConsumer } from '../context/state';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const SNACKBAR_AUTO_HIDE_DURATION = 6000;

const FormattedSnackbar = ({ className }: Props) => (
  <DependencyConsumer>
    {dependency => (
      <StateConsumer>
        {state => (
          <Component
            message={state.snackbar.message}
            messageValues={state.snackbar.messageValues || undefined}
            action={state.snackbar.action || undefined}
            actionValues={state.snackbar.actionValues || undefined}
            raw={state.snackbar.isRaw}
            onClickAction={state.snackbar.onClickAction || undefined}
            onRequestClear={() => dependency.messageDispatcher.clearUnimportant()}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION}
            className={className}
            error={state.snackbar.error}
            warning={undefined}
            info={undefined}
          />
        )}
      </StateConsumer>
    )}
  </DependencyConsumer>
);

export default FormattedSnackbar;
